import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {issuesAppBuilder} from './config/app-builder'
import {createIssuesRoutes} from './routes/create-issues-routes'
import {issuesDashboardSurfaceLayoutRoute} from './routes/issues-dashboard-surface-layout-route'
import {IssuesDashboardSurfaceLayoutComponent} from './routes/IssuesDashboardSurfaceLayout'
import {issuesDashboardSurfaceContentRoute} from './routes/issues-dashboard-surface-content-route'
import {IssuesDashboardSurfaceContentComponent} from './routes/IssuesDashboardSurfaceContent'
import {IssuesDashboardIndexGate} from './routes/IssuesDashboardIndexGate'
import {createDashboardRouteErrorBoundary} from '@github-ui/shared-dashboard-surface/components/shared/DashboardRouteErrorBoundary'

const IssuesDashboardRouteErrorBoundary = createDashboardRouteErrorBoundary({
  reactAppName: 'issues',
  resourceName: 'issues',
  boundaryName: 'IssuesDashboardRoute',
})

// Deferred (function) form keeps route construction at app registration time.
export const issuesApp = issuesAppBuilder.createDataRouterAppFromRoutes(() => [
  ...createIssuesRoutes(issuesAppBuilder),
  issuesDashboardSurfaceLayoutRoute.toRoute({
    Component: IssuesDashboardSurfaceLayoutComponent,
    errorBoundary: {override: IssuesDashboardRouteErrorBoundary},
    children: [
      {index: true, Component: IssuesDashboardIndexGate},
      issuesDashboardSurfaceContentRoute.toRoute({
        Component: IssuesDashboardSurfaceContentComponent,
        errorBoundary: {override: IssuesDashboardRouteErrorBoundary},
      }),
    ],
  }),
])
registerDataRouterApp(issuesApp)
